module.exports = __webpack_public_path__ + "static/media/testimonials4.dae764df.png";